import { render } from "./TreatmentReport.vue?vue&type=template&id=0e115551&ts=true"
import script from "./TreatmentReport.vue?vue&type=script&lang=ts"
export * from "./TreatmentReport.vue?vue&type=script&lang=ts"

import "./TreatmentReport.vue?vue&type=style&index=0&id=0e115551&lang=css"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__